// pages/ConstructionPage.jsx
// Page générique pour les fonctionnalités en construction

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import './ConstructionPage.css';

export default function ConstructionPage({ title, description }) {
  const { t } = useTranslation();

  return (
    <div className="construction-page">
      <div className="construction-card">
        <Construction size={80} color="#F59E0B" />
        <h2>{title || t('construction.titreDefaut')}</h2>
        <p>{description || t('construction.descriptionDefaut')}</p>
        <div className="construction-info">
          <p>{t('construction.info1')}</p>
          <p>{t('construction.info2')}</p>
        </div>
      </div>
    </div>
  );
}
